import * as React from 'react';
import Lightbulb from '@keaze/web/public/svg/lightbulb-icon.svg';
import { Box} from '@mui/system';
import styled from 'styled-components';

import {
  Staircase,
  StaircaseContent,
  MainContainer,
  StaircasedButton
    
  } from '../styles/staircase.styles'
import {SharedOwnerExplainedButton} from "@keaze/web/views/SharedOwnership/styles/SharedOwnershipExplained.styles";
  
  const S = {

    StaircaseImageContainer: styled(Box)`
  ${({ theme: { breakpoints, colors} }) => ` 

        justify-content: center;
        margin-bottom: -200px;
        padding: 40px 15px ;
        margin-top: 60px;
        background-repeat: no-repeat;
        height: 300px;
        // left: -225px;
        border-radius: 0 0 120px 0;
        background-size:cover;
    

 
    


    

  ${breakpoints.up('md')} {
    padding: 10px;
    border-radius: 0 0 120px 0;
    background-size: cover;
    margin-bottom: -200px;
    bottom: 0;
    top: 333px;
    position: relative;
    margin: unset;
    left: -363px;
    height: 642px !important;
    // height: 400px;
  

    width: 546px !important;
    // width: 546px !important;
    height: fit-content;
    overflow: hidden;
    position: absolute;
    z-index: 2;
           
            
             
        }
  `}
  `,
   }

type Props = {
    data: Record<string, never>
};

const StaircaseComponent = (props: Props) => {
    return (
        <MainContainer>
            <Staircase>
                <S.StaircaseImageContainer sx={{
                    backgroundImage: `url(${props.data.image ?? 'images/HomeStepper/PostSalesGuideImgOrange.png'})`
                }} />
                <StaircaseContent>
                    <Lightbulb/>
                    <h2>{props.data.title ?? 'Staircasing to buy more shares in your home'}</h2>
                    <div dangerouslySetInnerHTML={{__html: props.data.content ?? ''}}></div>

                    {!!props.data.file && (
                        <a href={props.data.file} target="_blank">
                            <StaircasedButton variant="outlined">
                                Download Guide
                            </StaircasedButton>
                        </a>
                    )}
                </StaircaseContent>
            </Staircase>
        </MainContainer>
)}

export default StaircaseComponent;